export type DiscountMode = 'kc' | 'percent'

export interface RiskDiscountPreview {
  discountKc: number
  discountPercent: number
  newPeriod: number
  newAnnual: number
}

export interface PremiumDiff {
  amountKc: number
  percent: number
}

export const roundWholeCzk = (value: number): number =>
  Math.sign(value) * Math.round(Math.abs(value))

export const parseCzkInput = (raw: string | undefined | null): number => {
  if (!raw) return 0
  const normalized = String(raw).replace(/\s/g, '').replace(',', '.')
  const value = Number.parseFloat(normalized)

  return Number.isFinite(value) ? value : 0
}

export const fmtKc = (value: number): string =>
  `${String(roundWholeCzk(value)).replace(/\B(?=(\d{3})+(?!\d))/g, ' ')} Kč`

export const fmtPctChip = (value: number): string =>
  `${Math.abs(value).toFixed(2).replace('.', ',')}%`

export const computeRiskDiscount = (
  basePeriodKc: number,
  mode: DiscountMode,
  value: number,
): RiskDiscountPreview => {
  const rawKc = mode === 'kc' ? roundWholeCzk(value) : roundWholeCzk(basePeriodKc * value / 100)
  const discountKc = Math.min(Math.max(rawKc, 0), basePeriodKc)
  const newPeriod = roundWholeCzk(basePeriodKc - discountKc)

  return {
    discountKc,
    discountPercent: basePeriodKc > 0 ? discountKc / basePeriodKc * 100 : 0,
    newPeriod,
    newAnnual: newPeriod * 12,
  }
}

export const diffOf = (base: number, next: number): PremiumDiff | null => {
  if (base === 0 || Math.abs(next - base) < 0.5) return null

  return {
    amountKc: next - base,
    percent: (next - base) / base * 100,
  }
}
